import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isExternalLink'
})
export class IsExternalLinkPipe implements PipeTransform {
  transform(link: string): boolean {
    const path = /^https?:\/\//i;
    return path.test(link);
  }
}
